import attachEventEmitter from 'event-emitter';

import * as types from './types';

export default class Events {
  types = types;

  constructor() {
    attachEventEmitter(this);
  }
}



// WEBPACK FOOTER //
// ./src/Events/Events.js